export enum Role {
  ADMIN = "admin",
  USER = "user",
}

export function castRoleEnum(value: Role) {
  switch (value) {
    case Role.ADMIN:
      return "ENUMS.ROLE.ADMIN";
    case Role.USER:
      return "ENUMS.ROLE.USER";
  }
}
